import { Box } from "@radix-ui/themes";
import logo from "../img/logo.svg";
import "./Header.css";
import { logout, getMe } from "../helper/sso";
import { useEffect, useState } from "react";

export default function Header({ py = "0" }: { py?: string }) {
  const [authenticated, setAuthenticated] = useState(false);

  const refreshAuth = async () => {
    const me = await getMe();
    setAuthenticated(!!me?.authenticated);
  };

  useEffect(() => {
    refreshAuth();

    const onAuthChanged = () => {
      refreshAuth();
    };

    window.addEventListener("auth-changed", onAuthChanged);
    return () => window.removeEventListener("auth-changed", onAuthChanged);
  }, []);

  return (
    <Box className="header" py={py}>
      <div className="header-inner">
        <a href="https://ama-assn.org/">
          <img src={logo} alt="American Medical Association Ed Hub" />
        </a>

        {authenticated && (
          <button className="header-logout" onClick={() => logout()}>
            Log out
          </button>
        )}
      </div>
    </Box>
  );
}
